import axiosInstance from "./axiosInstance";
import { toast } from "react-toastify";
import { ParseErrors } from "./parse-errors";

interface IUploadFile {
  file: File;
  onProgress: (prog: Record<string, any>) => void;
}

export interface IUploadFileResponse {
  status: number;
  data?: {
    type: string;
    fileLink: string;
    name: string;
  };
}

const UploadFile = async ({
  file,
  onProgress,
}: IUploadFile): Promise<IUploadFileResponse> => {
  try {
    let formData = new FormData();
    formData.append("fileData", file);

    const response = await axiosInstance.post("/file/public/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (data: any) => {
        let progress = Math.floor((data?.loaded / data?.total) * 100);
        onProgress({ [file.name]: progress });
      },
    });

    if (response.status === 200) {
      return {
        status: 200,
        data: { fileLink: response.data.key, name: file.name, type: "files" },
      };
    }

    return { status: 500 };
  } catch (error) {
    console.log(error);
    toast.error(ParseErrors(error));
    return { status: 500 };
  }
};

export default UploadFile;
